import { api } from '@/services'

export const fetchContracts = (params) => {
    return api.get('admin/contract/search', { params })
}
export const fetchContract = (id) => {
    return api.get(`admin/contract/show/${id}`)
}
export const createContract = (params) => {
    return api.post('admin/contract/create', params)
}

export const fetchServiceContract = (params) => {
  return api.get('web/serviceContract/show', { params: params })
}
